/*
 * TerriSTORY®
 *
 © Copyright 2022 AURA-EE
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * A copy of the GNU Affero General Public License should be present along
 * with this program at the root of current repository. If not, see
 * http://www.gnu.org/licenses/.
 */

import React from "react";
import { Link } from "react-router-dom";
import config from "../../settings.js";
import { consulteAutrePage } from "../../utils.js";

/**
 * This component is used to display the Support page
 */
class Support extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      didSendVisit: false
    };
  }
  componentDidUpdate() {
    if (this.props.parentApi.controller.gestionSuiviConsultations && !this.state.didSendVisit) {
      let region = this.props.parentApi.data.region;
      let idUtilisateur = this.props.parentApi.controller.gestionSuiviConsultations.idUtilisateur;
      let url = config.api_consultation_autre_page_url;
      consulteAutrePage(url, region, idUtilisateur, "Support", "");
      this.setState({
        didSendVisit: true
      });
    }
  }
  suiviConsultation(e) {
    let text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let region = this.props.parentApi.data.region;
    let idUtilisateur = this.props.parentApi.controller.gestionSuiviConsultations.idUtilisateur;
    let url = config.api_consultation_autre_page_url;
    let nomPdf = text;
    if (!text) {
      nomPdf = e.target.innerText;
    }
    consulteAutrePage(url, region, idUtilisateur, "Support - PDF", nomPdf);
    return false;
  }
  render() {
    let lien_faq_final = /*#__PURE__*/React.createElement("a", {
      href: config.faq_url.replace("#region#", this.props.parentApi.data.region) + "faq.pdf",
      target: "_blank",
      rel: "noreferrer"
    }, " ", "Foire aux questions");
    if (this.props.parentApi.data.region === "nouvelle-aquitaine") {
      return /*#__PURE__*/React.createElement("div", {
        className: "widgets full-screen-widget"
      }, /*#__PURE__*/React.createElement(Link, {
        className: "back-to-map",
        to: "/" + this.props.parentApi.data.urlPartageable
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "close close-big",
        "data-dismiss": "alert",
        "aria-label": "Close"
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "tout"
      }, /*#__PURE__*/React.createElement("div", {
        className: "support"
      }, /*#__PURE__*/React.createElement("div", {
        className: "img"
      }, /*#__PURE__*/React.createElement("img", {
        src: "../../img/logo_TerriSTORY_region_nouvelle_aquitaine_small.png",
        alt: "Logo de TerriSTORY"
      })), /*#__PURE__*/React.createElement("div", {
        className: "corps"
      }, /*#__PURE__*/React.createElement("p", null, "Bienvenue dans la page support aux utilisateurs de l'outil TerriSTORY\xAE."), /*#__PURE__*/React.createElement("p", null, "Cette page recense l'ensemble des ressources \xE0 disposition pour faciliter votre utilisation de l'outil."), /*#__PURE__*/React.createElement("p", null, "Bonne navigation\xA0!"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h3", null, "M\xE9thodologies de calcul et sources des donn\xE9es"), /*#__PURE__*/React.createElement("p", null, "Pour chaque indicateur, chaque installation, estimation d'impact, consulter la m\xE9thodologie de calcul et les sources en cliquant sur le", " ", /*#__PURE__*/React.createElement("img", {
        src: "./img/icon_help_small.png",
        alt: ""
      }), " ", "pr\xE9sent sur la page (g\xE9n\xE9ralement en haut \xE0 droite)."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h3", null, "R\xE9ponses aux questions "), /*#__PURE__*/React.createElement("ul", {
        className: "liste"
      }, /*#__PURE__*/React.createElement("li", null, "Les r\xE9ponses aux questions les plus fr\xE9quentes se trouvent dans la", lien_faq_final), /*#__PURE__*/React.createElement("li", null, "Pour toute autre question,", " ", /*#__PURE__*/React.createElement(Link, {
        to: "/contact"
      }, /*#__PURE__*/React.createElement("p", null, "contactez-nous"))))))));
    } else if (this.props.parentApi.data.region === "occitanie") {
      return /*#__PURE__*/React.createElement("div", {
        className: "widgets full-screen-widget"
      }, /*#__PURE__*/React.createElement(Link, {
        className: "back-to-map",
        to: "/" + this.props.parentApi.data.urlPartageable
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "close close-big",
        "data-dismiss": "alert",
        "aria-label": "Close"
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "tout"
      }, /*#__PURE__*/React.createElement("div", {
        className: "support"
      }, /*#__PURE__*/React.createElement("div", {
        className: "img"
      }, /*#__PURE__*/React.createElement("img", {
        src: "img/logo_TerriSTORY_region_occitanie.png",
        alt: "Logo de TerriSTORY"
      })), /*#__PURE__*/React.createElement("div", {
        className: "corps"
      }, /*#__PURE__*/React.createElement("p", null, "Bienvenue dans la page support aux utilisateurs de l'outil TerriSTORY\xAE."), /*#__PURE__*/React.createElement("p", null, "Cette page recense l'ensemble des ressources \xE0 disposition pour faciliter votre utilisation de l'outil."), /*#__PURE__*/React.createElement("p", null, "Bonne navigation !"), /*#__PURE__*/React.createElement("h3", null, "Tutoriels"), /*#__PURE__*/React.createElement("div", {
        className: "support-tutoriels"
      }, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "Pour d\xE9buter avec l'outil TerriSTORY\xAE laissez-vous guider par le document", " ", /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e),
        href: "https://auvergnerhonealpes.terristory.fr/pdf/auvergne-rhone-alpes/Premiers_pas.pdf"
      }, /*#__PURE__*/React.createElement("span", {
        className: "underline"
      }, "Premiers pas avec l'outil")), " ", "(PDF)"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
        href: "https://www.youtube.com/watch?v=U0azEEcjoF4"
      }, /*#__PURE__*/React.createElement("span", {
        className: "underline"
      }, "Pr\xE9sentation - d\xE9monstration de l'outil")), " ", "(vid\xE9o 38mn)"), /*#__PURE__*/React.createElement("li", null, "Pour d\xE9couvrir toutes les diff\xE9rentes fonctionnalit\xE9s de TerriSTORY\xAE, consultez les tuto d\xE9mo\xA0:", /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "D\xE9couverte de l'interface (", /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e, "Découverte de l'interface"),
        href: "https://auvergnerhonealpes.terristory.fr/pdf/auvergne-rhone-alpes/interface.pdf",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "PDF"), ")"), /*#__PURE__*/React.createElement("li", null, "Visualisation d'indicateurs (", /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e, "Visualisation d'indicateurs"),
        href: "https://auvergnerhonealpes.terristory.fr/pdf/auvergne-rhone-alpes/indicateurs.pdf",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "PDF"), ")"), /*#__PURE__*/React.createElement("li", null, "Cartographie des \xE9quipements (", /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e, "Cartographie des équipements"),
        href: "https://auvergnerhonealpes.terristory.fr/pdf/auvergne-rhone-alpes/equipements.pdf",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "PDF"), ")"), /*#__PURE__*/React.createElement("li", null, "Consultation d'analyses territoriales (", /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e, "Consultation d'analyses territoriales"),
        href: "https://auvergnerhonealpes.terristory.fr/pdf/auvergne-rhone-alpes/analyses-territoriales.pdf",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "PDF"), ")"), /*#__PURE__*/React.createElement("li", null, "Construction de strat\xE9gies territoriales : plans d'actions et impacts (", /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e, "Construction de stratégies territoriales : plans d'actions et impacts"),
        href: "https://auvergnerhonealpes.terristory.fr/pdf/auvergne-rhone-alpes/strategies.pdf",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "PDF"), ")"), /*#__PURE__*/React.createElement("li", null, "Consultation et cr\xE9ation de tableaux de bord (", /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e, "Consultation et création de tableaux de bord"),
        href: "https://auvergnerhonealpes.terristory.fr/pdf/auvergne-rhone-alpes/tableaux-de-bord.pdf",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "PDF"), ")"))), /*#__PURE__*/React.createElement("li", null, "Modules indicateurs :", " ", /*#__PURE__*/React.createElement("a", {
        href: "https://www.youtube.com/watch?v=jHZoNmfigjo&t=3s"
      }, "Tutoriel affichage des indicateurs"), " ", "(vid\xE9o 5mn)"), /*#__PURE__*/React.createElement("li", null, "Module synth\xE8se des indicateurs :", " ", /*#__PURE__*/React.createElement("a", {
        href: "https://www.youtube.com/watch?v=DLL235y5yds&t=3s"
      }, "Tutoriel affichage de la synth\xE8se des indicateurs territoriaux"), " ", "(vid\xE9o 7 mn)"), /*#__PURE__*/React.createElement("li", null, "Cr\xE9er un compte utilisateur", /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e),
        href: "https://auvergnerhonealpes.terristory.fr/pdf/auvergne-rhone-alpes/guide_creation_compte_utilisateur.pdf"
      }, "Guide de cr\xE9ation d'un compte utilisateur"), " ", "(PDF)"))), /*#__PURE__*/React.createElement("li", null, "Module strat\xE9gie territoriale", /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e),
        href: "https://www.youtube.com/watch?v=G1Rd-kBAotA"
      }, "Tutoriel cr\xE9er un plan d'action et en mesurer les impacts"), " ", "(vid\xE9o 9 mn)"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e),
        href: "https://auvergnerhonealpes.terristory.fr/pdf/auvergne-rhone-alpes/guide_plan_actions_transition_\xE9nerg\xE9tique.pdf"
      }, "Guide utilisateur et m\xE9thodologie du module strat\xE9gie territoriale"), " ", "(PDF)"))), /*#__PURE__*/React.createElement("li", null, "Module tableaux de bord", /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e),
        href: "https://auvergnerhonealpes.terristory.fr/pdf/auvergne-rhone-alpes/creation_tableau_de_bord.pdf"
      }, "Guide de construction d'un tableau de bord"), " ", "(PDF)"))))), /*#__PURE__*/React.createElement("h3", null, "M\xE9thodologies de calcul et sources des donn\xE9es"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "Pour chaque indicateur, chaque installation, estimation d'impact, consulter la m\xE9thodologie de calcul et les sources en cliquant sur le", " ", /*#__PURE__*/React.createElement("img", {
        src: "./img/icon_help_small.png",
        alt: ""
      }), " ", "pr\xE9sent sur la page (g\xE9n\xE9ralement en haut \xE0 droite).")), /*#__PURE__*/React.createElement("h3", null, "R\xE9ponses aux questions "), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "Les r\xE9ponses aux questions les plus fr\xE9quentes se trouvent dans la", " ", /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e),
        href: "https://arec-occitanie.terristory.fr/pdf/occitanie/faq.pdf"
      }, /*#__PURE__*/React.createElement("span", {
        className: "underline"
      }, "Foire aux questions"))), /*#__PURE__*/React.createElement("li", null, "Pour toute autre question,", " ", /*#__PURE__*/React.createElement(Link, {
        to: "/contact"
      }, /*#__PURE__*/React.createElement("p", null, "contactez-nous"))))))));
    } else if (this.props.parentApi.data.region === "auvergne-rhone-alpes") {
      return /*#__PURE__*/React.createElement("div", {
        className: "widgets full-screen-widget"
      }, /*#__PURE__*/React.createElement(Link, {
        className: "back-to-map",
        to: "/" + this.props.parentApi.data.urlPartageable
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "close close-big",
        "data-dismiss": "alert",
        "aria-label": "Close"
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "tout"
      }, /*#__PURE__*/React.createElement("div", {
        className: "support"
      }, /*#__PURE__*/React.createElement("div", {
        className: "img"
      }, /*#__PURE__*/React.createElement("img", {
        src: "../../img/logo_TerriSTORY_region_aura_small.png",
        alt: "Logo de TerriSTORY"
      })), /*#__PURE__*/React.createElement("div", {
        className: "corps"
      }, /*#__PURE__*/React.createElement("p", null, "Bienvenue dans la page support aux utilisateurs de l'outil TerriSTORY\xAE."), /*#__PURE__*/React.createElement("p", null, "Cette page recense l'ensemble des ressources \xE0 disposition pour faciliter votre utilisation de l'outil."), /*#__PURE__*/React.createElement("p", null, "Bonne navigation\xA0!"), /*#__PURE__*/React.createElement("h3", null, "Tutoriels"), /*#__PURE__*/React.createElement("div", {
        className: "support-tutoriels"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "liste"
      }, /*#__PURE__*/React.createElement("li", null, " ", "Pour d\xE9buter avec l'outil TerriSTORY\xAE laissez-vous guider par le document", " ", /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e),
        href: "../../pdf/auvergne-rhone-alpes/Premiers_pas.pdf",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Premiers pas avec l'outil"), " ", "(PDF)"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
        href: "https://www.youtube.com/watch?v=U0azEEcjoF4",
        rel: "noopener noreferrer"
      }, "Pr\xE9sentation - d\xE9monstration de l'outil", " "), "(vid\xE9o 38mn)"), /*#__PURE__*/React.createElement("li", null, "Pour d\xE9couvrir toutes les diff\xE9rentes fonctionnalit\xE9s de TerriSTORY\xAE, consultez les tuto d\xE9mo\xA0:"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "D\xE9couverte de l'interface (", /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e, "Découverte de l'interface"),
        href: "../../pdf/auvergne-rhone-alpes/interface.pdf",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "PDF"), ")"), /*#__PURE__*/React.createElement("li", null, "Visualisation d'indicateurs (", /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e, "Visualisation d'indicateurs"),
        href: "../../pdf/auvergne-rhone-alpes/indicateurs.pdf",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "PDF"), ")"), /*#__PURE__*/React.createElement("li", null, "Cartographie des \xE9quipements (", /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e, "Cartographie des équipements"),
        href: "../../pdf/auvergne-rhone-alpes/equipements.pdf",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "PDF"), ")"), /*#__PURE__*/React.createElement("li", null, "Consultation d'analyses territoriales (", /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e, "Consultation d'analyses territoriales"),
        href: "../../pdf/auvergne-rhone-alpes/analyses-territoriales.pdf",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "PDF"), ")"), /*#__PURE__*/React.createElement("li", null, "Construction de strat\xE9gies territoriales : plans d'actions et impacts (", /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e, "Construction de stratégies territoriales : plans d'actions et impacts"),
        href: "../../pdf/auvergne-rhone-alpes/strategies.pdf",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "PDF"), ")"), /*#__PURE__*/React.createElement("li", null, "Consultation et cr\xE9ation de tableaux de bord (", /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e, "Consultation et création de tableaux de bord"),
        href: "../../pdf/auvergne-rhone-alpes/tableaux-de-bord.pdf",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "PDF"), ")")), /*#__PURE__*/React.createElement("li", null, " ", "Module indicateurs :", " ", /*#__PURE__*/React.createElement("a", {
        href: "https://www.youtube.com/watch?v=jHZoNmfigjo&t=3s",
        rel: "noopener noreferrer"
      }, "Tutoriel affichage des indicateurs", " "), " ", "(vid\xE9o 5mn)"), /*#__PURE__*/React.createElement("li", null, " ", "Module synth\xE8se des indicateurs :", " ", /*#__PURE__*/React.createElement("a", {
        href: "https://www.youtube.com/watch?v=DLL235y5yds&t=3s",
        rel: "noopener noreferrer"
      }, "Tutoriel affichage de la synth\xE8se des indicateurs territoriaux", " "), "(vid\xE9o 7 mn)"), /*#__PURE__*/React.createElement("li", null, " ", "Cr\xE9er un compte utilisateur", /*#__PURE__*/React.createElement("ul", {
        className: "sous-liste"
      }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e),
        href: "../../pdf/auvergne-rhone-alpes/guide_creation_compte_utilisateur.pdf",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Guide de cr\xE9ation d'un compte utilisateur"), " ", "(PDF)"))), /*#__PURE__*/React.createElement("li", null, " ", "Module strat\xE9gie territoriale", /*#__PURE__*/React.createElement("ul", {
        className: "sous-liste"
      }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
        href: "https://www.youtube.com/watch?v=G1Rd-kBAotA",
        rel: "noopener noreferrer"
      }, "Tutoriel cr\xE9er un plan d'action et en mesurer les impacts", " "), "(vid\xE9o 9 mn)"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e),
        href: "../../pdf/auvergne-rhone-alpes/guide_plan_actions_transition_\xE9nerg\xE9tique.pdf",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Guide utilisateur et m\xE9thodologie du module strat\xE9gie territoriale"), " ", "(PDF)"))), /*#__PURE__*/React.createElement("li", null, " ", "Module tableaux de bord", /*#__PURE__*/React.createElement("ul", {
        className: "sous-liste"
      }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
        onClick: e => this.suiviConsultation(e),
        href: "../../pdf/auvergne-rhone-alpes/creation_tableau_de_bord.pdf",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Guide de construction d'un tableau de bord"), " ", "(PDF)"))))), /*#__PURE__*/React.createElement("h3", null, "Caf\xE9 d\xE9mo"), /*#__PURE__*/React.createElement("p", null, "Chaque 1er vendredi du mois, de 13h30 \xE0 14h, retrouvez l'\xE9quipe TerriSTORY\xAE lors d'un caf\xE9 d\xE9mo pour d\xE9couvrir les nouveaut\xE9s de l'outil, poser vos questions, \xE9changer avec d'autres utilisateurs, faire remonter vos besoins,..."), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
        href: "https://us02web.zoom.us/meeting/register/tZIlfuqupjsjGNBWPfKUkkj7hwtRaXi-2O-w"
      }, "Inscrivez-vous"), " ", "au prochain caf\xE9 d\xE9mo (r\xE9union en ligne par Zoom)"), /*#__PURE__*/React.createElement("h3", null, "M\xE9thodologies de calcul et sources des donn\xE9es"), /*#__PURE__*/React.createElement("p", null, "Pour chaque indicateur, chaque installation, estimation d'impact, consulter la m\xE9thodologie de calcul et les sources en cliquant sur le", " ", /*#__PURE__*/React.createElement("img", {
        src: "./img/icon_help_small.png",
        alt: ""
      }), " ", "pr\xE9sent sur la page (g\xE9n\xE9ralement en haut \xE0 droite)."), /*#__PURE__*/React.createElement("h3", null, "R\xE9ponses aux questions "), /*#__PURE__*/React.createElement("ul", {
        className: "liste"
      }, /*#__PURE__*/React.createElement("li", null, "Les r\xE9ponses aux questions les plus fr\xE9quentes se trouvent dans la", lien_faq_final), /*#__PURE__*/React.createElement("li", null, "Pour toute autre question,", " ", /*#__PURE__*/React.createElement(Link, {
        to: "/contact"
      }, /*#__PURE__*/React.createElement("p", null, "contactez-nous"))))))));
    } else {
      return "";
    }
  }
}
export default Support;